<template>
  <div class="bgVideo">
    <video
      ref="videoPlayer"
      :src="require('@assets/videos/' + src)"
      autoplay
      :poster="require('@assets/images/' + poster)"
      @timeupdate="onTimeUpdate(pause)"
      @ended="videoEnded"
    ></video>
  </div>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    src: {
      type: String,
      default: '',
    },
    pause: {
      type: Number,
      default: 0,
    },
    poster: {
      type: String,
      default: '2.1_planning.jpg',
    },
    next: {
      type: Boolean,
      default: false,
    },
    nextPath: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.$refs.videoPlayer.play()
    this.next = false
  },
  beforeDestroy() {},
  methods: {
    toggleNext: function() {
      this.next = !this.next
    },
    onTimeUpdate: function(pauseTime) {
      const vidEl = this.$refs.videoPlayer
      const vidTime = vidEl.currentTime
      if (vidTime > pauseTime && !this.next) {
        vidEl.pause()
        // console.log('Vid Paused at: ' + vidTime)
      }
    },
    videoEnded: function() {
      this.$router.push('/' + this.nextPath)
    },
    onPlay: function() {
      const vidEl = this.$refs.videoPlayer
      this.toggleNext()
      vidEl.play()
    },
  },
}
</script>

<style lang="scss">
.bgVideo {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;

  /* stylelint-disable */

  .vjs-hidden {
    display: none !important;
  }

  .vjs_video_3-dimensions.vjs-fluid {
    padding-top: 0 !important;
  }

  /* stylelint-enable */
}
</style>
